import styled from 'styled-components';

export const Conteiner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const TextoDeErro = styled.span`
  color: ${(props) => props.theme.DANGER};
`;

export const CheckboxesConteiner = styled.div`
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
`;

export const CheckboxConteiner = styled.span`
  display: flex;
  align-items: center;

  margin: 10px 100px 10px 0;
`;

export const TextoCheckbox = styled.label`
  margin: 0 5px;
`;
